// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"117b12eb","453":"7dd176ea"}[chunkId] + ".chunk.js";
};